import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const ArrowPointerRight: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5303 7.46967L8.53033 2.46967L7.46967 3.53033L11.1893 7.25H2V8.75H11.1893L7.46967 12.4697L8.53033 13.5303L13.5303 8.53033L14.0607 8L13.5303 7.46967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { ArrowPointerRight };
